var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiuxdesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Progressive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-7 9 284 284",
    style: {
      enableBackground: "new -7 9 284 284"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2458A6;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FF6347;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#FF6347;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#FF6347;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.1,60.8c14.5,0.1,29,0.1,43.5,0.2c1.9,0,3.3,2.1,3.3,5.1v59.6c0,21.7,0,43.5,0,65.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.8,210.9c-55.1,0-110.1,0-164.6,0c-3.1,0-5.2-2.1-5.2-5.1V66.2c0-1.5,0.5-2.6,1.6-3.6 c1-1,2.6-1.5,3.7-1.5c12,0,23.9-0.1,35.9-0.1c0.9,0,0.3,0,8.5,0c12.9,0,51-0.1,137.9-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.3,210.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.9,192.5v13.9c0,3.1-1.7,5.1-4.3,5.1H217"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "160.1,246.9 100,246.9 109.7,210.9 149.8,210.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 80,
    y1: 246.9,
    x2: 180.1,
    y2: 246.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 65,
    className: "st0",
    width: 173.3,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 108.3,
    className: "st0",
    width: 78.8,
    height: 66.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 144.7,
    y1: 109.3,
    x2: 180.1,
    y2: 109.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 144.7,
    y1: 129.3,
    x2: 168.8,
    y2: 129.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "193.6,139.5 215.6,139.6 215.4,230.8 193.4,230.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "204.6,116 193.6,137.5 215.6,137.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 214.2,
    y1: 211.6,
    x2: 194.6,
    y2: 211.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxdesign);
export default __webpack_public_path__ + "static/media/uiuxdesign.c9dadc2624fb2eb0705d7b3a48e9a243.svg";
export { ForwardRef as ReactComponent };